export const getProduct = (state, systemId) => state[systemId].product;
export const getProductVersion = (state, systemId) => state[systemId].version;
